<script setup lang="ts">
import { ref, watch, onUnmounted, onMounted } from 'vue';
import { Button } from '@/components/shadcnui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/shadcnui/select';
import { Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationPrevious, PaginationNext } from '@/components/shadcnui/pagination';
import { useRSStore } from '@/store/useRSStore';
import { useUserStore } from '@/store/useUserStore';
import { useUser } from '@/composable/useUser';

const RSStore = useRSStore();
const UserStore = useUserStore();
const { onUpdateUserConfig } = useUser();

const currentPage = ref(50);
const tableSize = ref([10, 20, 50, 100]);
const siblingOptions = ref([1, 2, 3, 4, 5])
const totalpage = ref(100)
const isSaved = ref(true);

const tablesizeValue = ref();
const siblingCountValue = ref();

const paginationHandler = async (page: number) => {
  if (page < 1) {
    page = 1;
  } else if (page > totalpage.value) {
    page = totalpage.value;
  }
  currentPage.value = page;
};

const saveSettings = () => {
  onUpdateUserConfig(UserStore.account, {
    tablesize: tablesizeValue.value,
    pnbtncount: siblingCountValue.value
  });
  UserStore.itemPerPage = tablesizeValue.value;
  UserStore.siblingCount = siblingCountValue.value;
  isSaved.value = true;
};

watch([() => tablesizeValue.value, () => siblingCountValue.value], () => {
  if (tablesizeValue.value !== UserStore.itemPerPage || siblingCountValue.value !== UserStore.siblingCount) {
    isSaved.value = false;
  } else {
    isSaved.value = true;
  }
});

onMounted(() => {
  tablesizeValue.value = UserStore.itemPerPage;
  siblingCountValue.value = UserStore.siblingCount;
});

onUnmounted(() => {
  if (!isSaved.value) {
    const confirmLeave = confirm("저장되지 않은 변경 사항이 있습니다. 저장하시겠습니까?");
    if (confirmLeave) {
      saveSettings();
    }
  }
});

</script>
<template>
  <div class="p-8 ">
    <div class="mb-6 ">
      <div class="flex items-start justify-between">
        <div class="flex items-center gap-3 mb-2">
          <div>
            <h1 class="text-3xl font-bold text-foreground">기본 설정</h1>
          </div>
        </div>
        <div></div>
        <div></div>
        <div></div>
        <div class="flex mr-10">
          <Button @click="saveSettings">저장</Button>
        </div>
      <div></div>
      </div>
    </div>
    <div class="grid gap-6 grid-cols-5">
      <div class="space-y-6 col-span-4">
        <div class="flex items-center justify-between space-x-4 rounded-lg border p-4 shadow-sm">
          <div class="space-y-1 flex-1">
            <p class="text-sm font-medium leading-none">테이블 행 개수</p>
            <p class="text-sm text-muted-foreground">
              테이블에 표시할 데이터의 개수를 선택
            </p>
          </div>
          <div class="w-48 shrink-0"> <Select v-model="tablesizeValue">
              <SelectTrigger>
                <SelectValue placeholder="개수 선택" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem v-for="option in tableSize" :key="option" :value="option">
                  {{ option }}개씩
                </SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        <div class="rounded-lg border p-4 shadow-sm">
        <div class="flex items-center justify-between space-x-4  ">
          <div class="space-y-1 flex-1">
            <p class="text-sm font-medium leading-none">페이지네이션</p>
            <p class="text-sm text-muted-foreground">
              페이지네이션에서 현재 버튼 양옆에 표시할 버튼 수
            </p>
          </div>
          <div class="w-48 shrink-0">
            <Select v-model="siblingCountValue">
              <SelectTrigger>
                <SelectValue placeholder="" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem v-for="option in siblingOptions" :key="option" :value="option">
                  {{ option }}
                </SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        <div class="mt-4 mb-4 flex justify-center">
          <Pagination v-model:page="currentPage" :total="100" :items-per-page="1" :sibling-count="siblingCountValue"
            show-edges>
            <PaginationContent v-slot="{ items }" class="flex items-center gap-1">
              <PaginationPrevious @click="paginationHandler(currentPage - RSStore.nextunit)" />
              <template v-for="(item, index) in items">
                <PaginationItem v-if="item.type === 'page'" :key="index" :value="item.value" as-child>
                  <Button class="w-10 h-10 p-0" :variant="item.value === currentPage ? 'default' : 'outline'"
                    @click="paginationHandler(item.value)">
                    {{ item.value }}
                  </Button>
                </PaginationItem>
                <PaginationEllipsis v-else :key="item.type" :index="index" />
              </template>
              <PaginationNext @click="paginationHandler(currentPage + RSStore.nextunit)" />
            </PaginationContent>
          </Pagination>
        </div>
      </div>
      </div>
      <div class="space-y-6">
        <!--
        설정 추가시 영역
        <Card>
          <CardHeader>
            <CardTitle class="text-lg">페이지네이션 설정</CardTitle>
          </CardHeader>
          <CardContent class="space-y-4">
          </CardContent>
        </Card>
        -->
      </div>
    </div>
  </div>

</template>
